var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V70H69.7428V0H0ZM65.0532 65.3153H4.68961V4.68468H65.0532V65.3153Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8022 45.4054C54.8022 37.3574 48.2488 30.8408 40.2224 30.8408H35.2923V35.5255H40.2224C45.6936 35.5255 50.1427 39.97 50.1427 45.4354C50.1427 50.9009 45.6936 55.3453 40.2224 55.3453H23.7787V18.2583H30.2419V13.5736H19.0891V60H40.1923C48.2488 60 54.8022 53.4535 54.8022 45.4054Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.858 27.958H52.5476C52.5476 16.967 43.6193 8.04805 32.6168 8.04805H32.5567V12.7327H32.6168C41.034 12.7327 47.858 19.5796 47.858 27.958Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5451 28.2583H46.2347C46.2347 20.6607 40.042 14.4444 32.4064 14.4444H32.2561V19.1291H32.4064C37.4567 19.1592 41.5451 23.2432 41.5451 28.2583Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2021 28.2583H39.8917C39.8917 24.1141 36.5248 20.7808 32.4064 20.7808H32.2861V25.4655H32.4064C33.9395 25.4655 35.2021 26.7267 35.2021 28.2583Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.236cf56548898c55feeccbe87d8a0a35.svg";
export { ForwardRef as ReactComponent };